import { useLandingLanguage } from '../../components/Public/LandingLanguage';
import React from 'react';

const WidgetPreview = ({ day }: { day: Date }) => {
  const { t, locale } = useLandingLanguage();
  const parts = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Bucharest', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(day);
  const part = (type: string) => Number(parts.find(value => value.type === type)?.value);
  const year = part('year'), month = part('month') - 1, today = part('day');
  const lastDay = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  const nextMonth = today + 3 > lastDay;
  const first = new Date(Date.UTC(year, month + (nextMonth ? 1 : 0), 1));
  const days = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate();
  const offset = (first.getUTCDay() + 6) % 7;
  const start = nextMonth ? 2 : today + 1;
  const end = start + 2;
  const monthLabel = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(first);
  const shortMonth = new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' }).format(first);
  return <figure className="orarivo-widget-preview">
    <div role="img" aria-label={locale === 'en-GB' ? `Orarivo calendar preview: ${monthLabel}, selected period ${start}–${end} ${shortMonth}; unavailable days are red.` : `Exemplu de calendar Orarivo: ${monthLabel}, perioadă selectată ${start}–${end} ${shortMonth}; zilele indisponibile sunt roșii.`}>
      <div aria-hidden="true">
        <h3>{t("Alege o perioadă")}</h3>
        <div className="orarivo-widget-preview-month">{monthLabel}</div>
        <div className="orarivo-widget-preview-week">{(locale === 'en-GB' ? ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'] : ['Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ', 'Du']).map(label => <span key={label}>{label}</span>)}</div>
        <div className="orarivo-widget-preview-grid">
          {Array.from({ length: offset }, (_, index) => <span key={`blank-${index}`}/>)}
          {Array.from({ length: days }, (_, index) => {
            const date = index + 1;
            const selected = date >= start && date <= end;
            const unavailable = (!nextMonth && date < today) || date === end + 3 || date === end + 4;
            const state = date === start || date === end ? 'selected' : selected ? 'range' : unavailable ? 'unavailable' : '';
            return <span className={state} key={date}>{date}</span>;
          })}
        </div>
        <div className="orarivo-widget-preview-legend"><span><i/>{t("Indisponibil")}</span><strong>{start}–{end} {shortMonth} · {t("2 nopți")}</strong></div>
      </div>
    </div>
    <figcaption>{t("Previzualizare widget · disponibilitate ilustrativă.")}</figcaption>
  </figure>;
};
export default WidgetPreview;
